module.exports = __webpack_public_path__ + "img/Rookie-4.775a901a.png";